<template>
<div data-v-0a095747="" class="delivery-setting">
    <div class="main">
        <div class="form">
            <el-form :model="settingRuleForm" label-width="100px" class="demo-ruleForm">
                <div class="delivery-formTitle">配送设置</div>
                <div class="delivery-formContent">
                    <el-form-item label="每公里费用">
                        <el-input v-model="settingRuleForm.unitLongMoney"></el-input>
                    </el-form-item>
                    <el-form-item label="每小时费用">
                        <el-input v-model="settingRuleForm.unitHourMoney"></el-input>
                    </el-form-item>
                </div>
                <el-form-item class="delivery-submit">
                    <el-button type="primary" @click="submitForm()">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</div>
</template>
<script>
import {mapGetters} from 'vuex';
export default {
    data() {
        return {
            // formRule: [],
            settingRuleForm: {
                unitLongMoney: '',
                unitHourMoney: ''
            },
            manage_id: '',
        }
    },
    computed: {
        ...mapGetters(['user'])
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            this.axios.get('dispatching_settings')
            .then(res => {
                this.settingRuleForm.unitLongMoney = res.data.data.kilometre_percost;
                this.settingRuleForm.unitHourMoney = res.data.data.hour_percost;
                this.manage_id = res.data.data.manager_id;
            })
        },
        submitForm() {
            if(this.user.id != this.manage_id) {
                this.$message({
                    type: 'error',
                    message: '非法的操作！'
                })
                return ;
            }
            if(this.settingRuleForm.unitLongMoney == '') {
                this.$message({
                    type: 'error',
                    message: '每公里费用不能为空!'
                })
                return;
            }
            if(this.settingRuleForm.unitHourMoney == '') {
                this.$message({
                    type: 'error',
                    message: '每小时费用不能为空!'
                });
                return;
            }
            var sendObj = {
                kilometre_percost: this.settingRuleForm.unitLongMoney,
                hour_percost: this.settingRuleForm.unitHourMoney
            }
            this.axios.post('dispatching_settings', JSON.stringify(sendObj))
            .then(res => {
                this.$message({
                    type: "success",
                    message: res.data.msg
                })
            })
        }
    }
}
</script>
<style scoped>
.delivery-setting {
    width: 100%;
    height: 600px;
    background-color: #f1f1f1;
}
.form{
    position: absolute;
    top: 200px;
    left: 50%;
    transform: translate(-50%);
    width: 615px;
    height: 359px;
}
.delivery-formTitle {
    width: 615px;
    height: 113px;
    background-color: #00b662;
    font-size: 22px;
    line-height: 113px;
    text-align: center;
    color: #fff;
    font-family: PingFangSC-Medium,Microsoft YaHei;
    border-radius: 6px 6px 0 0;
}
.delivery-formContent {
    padding: 80px 163px;
    background-color: #fff;
    border-radius: 0 0 7px 7px;
}

</style>
<style>
.delivery-submit .el-form-item__content {
        margin-left: 0!important;
}
.delivery-submit .el-button {
    position: absolute;
    top: 40px;
    left: 50%;
    width: 100px;
    height: 40px;
    border-radius: 22.5px;
    background: #00ae66;
    border: none;
    transform: translate(-50%);
}
</style>






// WEBPACK FOOTER //
// src/pages/deliveryManage/DeliverySetting.vue